import styled from 'styled-components';

export const PatientForm = styled.div`
	display: flex;
	flex-direction: column;
	flex: 1;
	background-color: #F5F5F5;
	@media only screen and (max-width: 600px) {
		background-color: #FFF;
	}
`;

PatientForm.SignatureBox = styled.div`
	height: 160px;
	text-align: ${({ hasSignature }) => hasSignature ? 'center' : 'left'};
	border: 1px solid #D9E1E8 !important;
	cursor: pointer;
	background: white;
	border-radius: 8px;
	padding: 8px 16px;
`;

PatientForm.SignatureBox.Placeholder = styled.span`
	fnt-weight: 400;
	font-size: 16px;
	line-height: 24px;
	color: #767B7F;
`;

PatientForm.SignatureBox.Image = styled.img`
	width: 260px;
	height: 140px;
	margin: 0 auto;
`;
